<template>
    <div class="open-block-but-better" ref="block">
        <slot :toggle="toggle" :isOpen="isOpen"></slot>
    </div>
</template>
<script>
// work only with this markup
// <OpenBlockButBetter>
//     <template slot-scope="{ toggle }">
//         <div class="open-block-but-better">
//             <div class="open-block-but-better__label" @click="toggle($event)">some label</div>
//             <div class="open-block-but-better__wrapper">
//                 <div class="open-block-but-better__content">some content</div>
//             </div>
//         </div>
//     </template>
// </OpenBlockButBetter>
export default {
    name: "OpenBlock",
    data() {
        return {
            isOpen: false,
            height: 0,
            maxHeight: 0,
            content: null,
            label: null,
            block: null,
        };
    },
    props: {
        state: {
            default: 42,
        },
        heightMod: {
            default: 0,
        },
    },
    watch: {
        state() {
            this.toggle();
        },
        heightMod(v) {
            let block = this.$refs.block;
            let label = block.firstChild.firstChild;
            let content = label.nextElementSibling;
            content.removeAttribute("style");
            this.maxHeight = content.firstChild.offsetHeight + v;
            this.height = this.maxHeight;
            this.content.style.height = this.height;
        },
    },
    methods: {
        toggle() {
            this.$nextTick(() => {
                this.$emit("toggle", !this.isOpen);
                this.isOpen = this.state !== 42 ? this.state : !this.isOpen;
                this.height = this.isOpen ? this.maxHeight : 0;
                this.content.style.height = this.height + "px";
                this.isOpen ? this.block.classList.add("is_open") : this.block.classList.remove("is_open");
            });
        },
    },
    mounted() {
        let block = this.$refs.block;
        if (block) {
            let label = block.firstChild.firstChild;
            if (label) {
                let content = label.nextElementSibling;
                if (content && content.firstChild) {
                    this.block = block;
                    this.label = label;
                    this.content = content;
                    this.maxHeight = content.firstChild.offsetHeight + this.heightMod;

                    this.label.classList.add("open-block-but-better__toggler");
                    this.content.classList.add("open-block-but-better__content");
                    this.content.style.height = this.height;

                    let target = content;
                    // Конфигурация observer (за какими изменениями наблюдать)
                    const config = {
                        childList: true,
                        subtree: true,
                    };
                    // Функция обратного вызова при срабатывании мутации
                    const callback = () => {
                        this.$nextTick(() => {
                            this.maxHeight = content.firstChild.offsetHeight + this.heightMod;
                            this.height = this.maxHeight;
                        });
                    };
                    // Начинаем наблюдение за настроенными изменениями целевого элемента
                    const observer = new MutationObserver(callback);
                    if (target) {
                        observer.observe(target, config);
                    }
                    if (this.state) {
                        this.toggle();
                    }
                }
            }
        }
    },
};
</script>
<style lang="less">
.open-block-but-better {
    position: relative;
    &__wrapper {
        overflow: hidden;
        transition: height 0.3s ease;
    }
}
</style>
